import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "pages/Home";
import Layout from "components/Layout";
import Signup from "pages/Signup";
import Login from "pages/Login";
import Authenticate from "pages/Authenticate";
import DevHome from "pages/DevTools/DevHome";
import GeneralManagerHub from "pages/GeneralManagerHub/GeneralManagerHub";
import TransactionManagerHub from "./pages/TransactionManagerHub/TransactionManagerHub";
import AdminHub from "./pages/AdminHub/AdminHub";
import TechHub from "./pages/TechHub/TechHub";
import UserMatches from "pages/UserMatches";
import UserNews from "pages/UserNews";
import TeamProfile from "pages/Team/TeamProfile";
import TeamsOverview from "pages/Team/TeamsOverview";
import FranchiseProfile from "pages/Franchise/FranchiseProfile";
import FranchisesOverview from "pages/Franchise/FranchisesOverview";
import FranchiseMatches from "pages/Franchise/FranchiseMatches";
import FranchiseNews from "pages/Franchise/FranchiseNews";
import UsersOverview from "pages/User/UsersOverview";
import UserProfile from "pages/User/UserProfile";
import DefaultLanding from "pages/DefaultLanding";
import TeamMatches from "pages/Team/TeamMatches";
import TeamNews from "pages/Team/TeamNews";
import MatchDetails from "pages/Match/MatchDetails";
import MatchHistory from "pages/Match/MatchHistory";
import GameDetails from "pages/Match/GameDetails";
import CombineQueue from "pages/Combine/CombineQueue";
import NotFoundPage from "pages/NotFoundPage";
import About from "pages/About";


export default function App(){
    return <>
        <BrowserRouter>
            <Routes>
                <Route element={<Layout/>}>
                    <Route index element={<DefaultLanding/>}/>
                    <Route path="/signup" element={<Signup/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/authenticate" element={<Authenticate/>}/>
                    <Route path="/gm-hub/*" element={<GeneralManagerHub/>}/>
                    <Route path="/tm-hub/*" element={<TransactionManagerHub/>}/>
                    <Route path="/admin-hub/*" element={<AdminHub/>}/>
                    <Route path="/tech-hub" element={<TechHub/>}/>
                    {/* DevTools only available in development mode */}
                    {import.meta.env.DEV && (
                        <Route path="/dev-tools" element={<DevHome/>}/>
                    )}
                    <Route path="/me/matches" element={<UserMatches/>}/>
                    <Route path="/me/news" element={<UserNews/>}/>
                    <Route path="/teams" element={<TeamsOverview/>}/>
                    <Route path="/teams/:teamId" element={<TeamProfile/>}/>
                    <Route path="/teams/:teamId/matches" element={<TeamMatches/>}/>
                    <Route path="/teams/:teamId/news" element={<TeamNews/>}/>
                    <Route path="/franchises" element={<FranchisesOverview/>}/>
                    <Route path="/franchises/:franchiseId" element={<FranchiseProfile/>}/>
                    <Route path="/franchises/:franchiseId/matches" element={<FranchiseMatches/>}/>
                    <Route path="/franchises/:franchiseId/news" element={<FranchiseNews/>}/>
                    <Route path="/users" element={<UsersOverview/>}/>
                    <Route path="/users/:userId" element={<UserProfile/>}/>
                    <Route path="/matches" element={<MatchHistory/>}/>
                    <Route path="/matches/:matchId" element={<MatchDetails/>}/>
                    <Route path="/matches/:matchId/games/:gameNo" element={<GameDetails/>}/>
                    <Route path="/combines/queue" element={<CombineQueue/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="*" element={<NotFoundPage/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    </>

}
